// for loading first
window.addEventListener('load', function() {
  const el = document.querySelector('[data-loading="first"]');
  if (el) {
    el.style.opacity = '0';
    el.style.visibility = 'hidden';
    setTimeout(() => {
      el.style.opacity = '1';
      el.style.visibility = 'visible';
    },);
  }
});


// for observe movie
document.addEventListener('DOMContentLoaded', function() {
  const video = document.querySelector('video');
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible' && video) {
      video.play();
    }
  });
});


// for scroll effect at top
document.addEventListener('DOMContentLoaded', function() {
  const elements = document.querySelectorAll('[data-effect="scroll"]');
  if (elements.length === 0) return;
  function toggleEffectClass() {
    elements.forEach((element) => {
      if (window.scrollY > 60) {
        element.classList.add('has-scroll');
      } else {
        element.classList.remove('has-scroll');
      }
    });
  }
  toggleEffectClass();
  window.addEventListener('scroll', toggleEffectClass);
});


// for scroll effect at bottom
document.addEventListener('DOMContentLoaded', function() {
  window.addEventListener('scroll', () => {
    const footerOutElem = document.querySelector('[data-effect="bottom"]');
    if (!footerOutElem) return;
    const isAtBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight;
    if (isAtBottom) {
      footerOutElem.classList.add('as-bottom');
    } else {
      footerOutElem.classList.remove('as-bottom');
    }
  });
});


// for fadein inpage
document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll('[data-effect="inpage"]');
  const onScroll = () => {
    const triggerPoint = window.innerHeight * (4.8 / 5);
    elements.forEach(el => {
      const rect = el.getBoundingClientRect();
      if (rect.top < triggerPoint && rect.bottom > 0) {
        el.classList.add("is-show");
      }
    });
  };
  window.addEventListener("scroll", onScroll);
  window.addEventListener("resize", onScroll);
  onScroll();
});


// for scroll lazy
document.addEventListener("DOMContentLoaded", function () {
  const lazyScrollElements = document.querySelectorAll('[data-scroll="lazy"]');
  if (lazyScrollElements.length === 0) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const el = entry.target;
      if (entry.isIntersecting) {
        el.dataset.inview = "true";
      } else {
        el.dataset.inview = "false";
      }
    });
  }, {
    root: null,
    threshold: 0,
  });
  lazyScrollElements.forEach(el => {
    observer.observe(el);
  });
  function getParallaxOffset(el) {
    const speed = parseFloat(el.getAttribute("data-speed")) || 0.1;
    const rect = el.getBoundingClientRect();
    const direction = el.getAttribute("data-direction") || "vertical";
    if (direction === "left") {
      return { x: rect.top * speed, y: 0 };
    } else if (direction === "right") {
      return { x: -rect.top * speed, y: 0 };
    } else {
      return { x: 0, y: -rect.top * speed };
    }
  }
  function updateParallax() {
    lazyScrollElements.forEach(el => {
      if (el.dataset.inview === "true") {
        const offset = getParallaxOffset(el);
        el.style.transform = `translate(${offset.x}px, ${offset.y}px)`;
      }
    });
  }
  function onScroll() {
    requestAnimationFrame(updateParallax);
  }
  window.addEventListener("scroll", onScroll);
  window.addEventListener("load", updateParallax);
});


// for scroll top anchor
document.querySelectorAll('[data-scroll-direction]').forEach(button => {
  button.addEventListener('click', function() {
    const direction = button.getAttribute('data-scroll-direction');
    if (direction === 'top') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const target = document.querySelector(`[data-scroll-anchor="${direction}"]`);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }
  });
});


// for target blank
document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll('a');
  for (let i = 0; i < links.length; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
});


// for contact by e-mail
document.addEventListener("DOMContentLoaded", function () {
  const email = "info@setsuna-fragance.com";
  const subject = "setsuna fragranceへのお問い合わせ";
  const body = `setsuna fragranceへのお問い合わせは下記にご記入ください。\n\nお名前：\nフリガナ：\nご用件：\nお電話番号：`;
  const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  document.querySelectorAll('[data-name="mailto"]').forEach(el => {
    el.setAttribute("href", mailtoLink);
  });
});

